module.exports = __webpack_public_path__ + "static/media/bachericonmetathumbnail.23fb425b.jpg";